import React from "react";
import { connect } from "react-redux";
import { clearError } from "../../redux/actions/Errors";
import CloseButton from "../../components/CloseButton/CloseButton";
import "./Error.css";

/**
 * Site wide error sub component
 * Using the error state
 *
 * @param clear
 * @param error
 * @returns {*}
 * @constructor
 */
const Error = ({ clear, error }) => {
  if (error) {
    return (
      <div className="PageError">
        <p className="PageError__Message">{error.message}</p>
        <small className="PageError__Hint">{renderHint(error.hint)}</small>
        <CloseButton onClick={clear} />
      </div>
    );
  }

  return null;
};

const renderHint = hint => {
  if (hint instanceof Object) {
    return (
      <ul>
        {Object.keys(hint).map((field, key) => (
          <li key={key}>{hint[field]}</li>
        ))}
      </ul>
    );
  } else {
    return hint;
  }
};

const mapStateToProps = ({ messages }) => ({
  error: messages.error
});

const mapDispatchToProps = dispatch => {
  return {
    clear: () => {
      dispatch(clearError());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Error);



// WEBPACK FOOTER //
// ./src/containers/App/Error.js